











































































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator'
import ApiService from '@/services/apiService'
import { UrlType } from '@/constants/urlType'
import ExtensionInfoCreateModel from '@/models/extension/extensionInfoCreateModel'
import InfoItemListAdmin from '@/components/lists/InfoItemListAdmin.vue'
import AddDialog from '@/components/dialogs/AddDialog.vue'
import { getModule } from 'vuex-module-decorators'
import TitleModule from '@/store/titleModule.ts'
import ExtensionModule from '@/store/extensionModule.ts'
import StageConstants from '@/constants/stageConstants.ts'
import LoadingIndicator from '@/components/loading/LoadingIndicator.vue'
import Validation from '@/mixins/validation.ts'
import ExtensionInfoListModel from '../models/extension/extensionInfoListModel'
import ExtensionInfoItemModel from '../models/extension/extensionInfoItemModel'
import ExtensionInfoItemCreateModel from '../models/extension/extensionInfoItemCreateModel'
import ExtensionInfoModel from '@/models/extension/extensionInfoModel'

const titleModule = getModule(TitleModule)
const extensionModule = getModule(ExtensionModule)

@Component({
  components: {
    InfoItemListAdmin,
    AddDialog,
    LoadingIndicator
  }
})
export default class StageInfoAdmin extends Mixins(Validation) {
  @Prop(String) readonly stage!: string

  private stageKey: string = ''
  private dialog: boolean = false
  private dialogInfo: boolean = false
  private infos: Array<ExtensionInfoListModel> = []
  private info: string | ExtensionInfoListModel = ''
  private loading: boolean = true
  private infoItem: ExtensionInfoItemModel = new ExtensionInfoItemModel()
  private editInfoModel: ExtensionInfoModel = new ExtensionInfoModel()
  private valid: boolean = true
  private isEdit: boolean = false

  get formattedStage() {
    const stageName = this.stage.replace(/-/g, ' ')
    return stageName.charAt(0).toUpperCase() + stageName.slice(1)
  }

  get modalTitle() {
    return this.isEdit ? 'Edit Information Item' : 'New Information Item'
  }

  private async created() {
    this.stageKey = StageConstants.getKeyByValue(this.stage)
    titleModule.setPageTitle(this.formattedStage)
    this.subscribeToModalOpen()
    await this.getInfos()
  }

  private async getInfos(): Promise<void> {
    this.infos = await ApiService.getQuestionsByExtension<
      ExtensionInfoListModel
    >(UrlType.ExtensionInfo, extensionModule.getExtensionId, this.stageKey)
    this.loading = false
  }

  private async editInfoItem(infoItem: ExtensionInfoItemModel): Promise<void> {
    this.infoItem = Object.assign({}, infoItem)
    this.isEdit = true

    this.info = await ApiService.get(
      UrlType.ExtensionInfoBase,
      this.infoItem.extensionInfoId
    )

    this.dialog = true
  }

  private async saveInfoItem(): Promise<void> {
    if (this.isEdit) {
      await this.updateInfoItem()
    } else {
      await this.createInfoItem()
    }
  }

  private async createInfoItem(): Promise<void> {
    const createModel: ExtensionInfoCreateModel = {
      info: this.info,
      infoItem: this.infoItem.details,
      stage: this.stageKey,
      extensionId: extensionModule.getExtensionId
    }

    if (typeof createModel.info === 'string') {
      await ApiService.post(
        UrlType.ExtensionInfoBase + '/infoItem',
        createModel
      )
    } else {
      let selectedInfo = this.info as ExtensionInfoListModel
      let createInfoItem = new ExtensionInfoItemCreateModel()

      createInfoItem.extensionInfoId = selectedInfo.extensionInfoId
      createInfoItem.details = this.infoItem.details
      await ApiService.post(UrlType.ExtensionInfoItemBase, createInfoItem)
    }

    this.dialog = false
    await this.getInfos()
  }

  private async updateInfoItem(): Promise<void> {
    if (typeof this.info === 'string') {
      // create new info
      const createModel: ExtensionInfoCreateModel = {
        info: this.info,
        infoItem: '',
        stage: this.stageKey,
        extensionId: extensionModule.getExtensionId
      }

      await ApiService.put(
        UrlType.ExtensionInfoBase + '/infoItem',
        this.infoItem.extensionInfoItemId,
        createModel
      )
    } else {
      // just put info item
      this.infoItem.extensionInfoId = this.info.extensionInfoId

      await ApiService.put(
        UrlType.ExtensionInfoItemBase,
        this.infoItem.extensionInfoItemId,
        this.infoItem
      )
    }
    this.dialog = false
    await this.getInfos()
  }

  private closeDialog(): void {
    this.isEdit = this.dialog = false
    this.dialogInfo = false
  }

  private subscribeToModalOpen(): void {
    this.$root.$on('openNavbarModal', () => {
      this.dialog = true
    })
  }

  private async moveCategoryDown(id: string) {
    await ApiService.putOrder<ExtensionInfoListModel>(
      UrlType.ExtensionInfoBase + '/orderdown',
      id
    )
    await this.getInfos()
  }

  private async moveCategoryUp(id: string) {
    await ApiService.putOrder<ExtensionInfoListModel>(
      UrlType.ExtensionInfoBase + '/orderup',
      id
    )
    await this.getInfos()
  }

  private async editInfo(model: ExtensionInfoModel) {
    this.editInfoModel = Object.assign({}, model)
    this.dialogInfo = true
  }

  private async updateInfo() {
    await ApiService.put(
      UrlType.ExtensionInfoBase,
      this.editInfoModel.extensionInfoId,
      this.editInfoModel
    )
    this.dialogInfo = false
    await this.getInfos()
  }

  private async deleteInfo(id: string) {
    if (confirm('Are you sure you want to delete this item?')) {
      await ApiService.delete(UrlType.ExtensionInfoBase, id)
      await this.getInfos()
    }
  }
}
